import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable, ModuleWithProviders, NgModule } from "@angular/core";
import { Observable } from "rxjs";
import { CommunicationType, SignUpRequest, SignUpResponse, GenerateOtpResponse, GenerateOtpRequest, VerifyOtpResponse, VerifyOtpRequest } from "../interfaces/signUp.interface";
import { AuthService } from "../../auth/auth.service";

@Injectable({
  providedIn: 'root',
})
export class SignUpService {
  constructor(
    private http: HttpClient,
    @Inject('environment') private environment: any,
    private authService: AuthService
  ) {}

  isEmailMobileUnique(
    communicationType: string,
    receiver: string,
    appName?: string
  ): Observable<any> {
    const postData: any = {appName};
    let subUrl: string = `${this.environment.apiUrl}/signup/`;
    if (communicationType === CommunicationType.EMAIL) {
      postData.email = receiver;
      subUrl += 'isEmailExists';
    } else {
      postData.mobile = receiver;
      subUrl += 'isMobileExists';
    }
    return this.http.post<any>(subUrl, postData);
  }

  isEmailMobileUniqueExceptSelf(
    _id: string,
    communicationType: string,
    receiver: string
  ): Observable<any> {
    const postData: any = {
      id: _id
    };
    // added token into header because this API is calling for inner pages
    const token = this.authService.getAccessToken();
    const headers: any = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
    let subUrl: string = `${this.environment.apiUrl}/signup/`;
    if (communicationType === CommunicationType.EMAIL) {
      postData.email = receiver;
      subUrl += 'isEmailExistsExceptSelf';
    } else {
      postData.mobile = receiver;
      subUrl += 'isMobileExistsExceptSelf';
    }
    return this.http.post<any>(subUrl, postData, {headers});
  }

  signup(data: SignUpRequest): Observable<SignUpResponse> {
    const url = `${this.environment.apiUrl}/signup/create`;
    data.isSelfEnrolled = true;
    return this.http.post<SignUpResponse>(url, data);
  }

  generateOtp(
    communicationType: string,
    receiver: string,
    verificationType: string = 'SignUp',
    appName?: string 
    ): Observable<GenerateOtpResponse> {
    const url = `${this.environment.apiUrl}/otp/generate`;
    const data: GenerateOtpRequest = {
      communicationType:
        communicationType === CommunicationType.EMAIL
          ? CommunicationType.EMAIL
          : CommunicationType.MOBILE,
      receiver: receiver,
      verificationType,
      appName
    };
    return this.http.post<GenerateOtpResponse>(url, data);
  }

  verifyOtp(
    communicationType: string,
    receiver: string,
    otp: string,
    appName?: string
  ): Observable<VerifyOtpResponse> {
    const url = `${this.environment.apiUrl}/otp/verify`;
    const data: VerifyOtpRequest = {
      communicationType:
        communicationType === CommunicationType.EMAIL
          ? CommunicationType.EMAIL
          : CommunicationType.MOBILE,
      receiver: receiver,
      verificationType: 'SignUp',
      otp: otp,
      appName
    };
    return this.http.post<VerifyOtpResponse>(url, data);
  }

  fetchInvitationData(inviteId: any) {
    const url = `${this.environment.apiUrl}/admin/getAdmin/${inviteId}`;
    return this.http.get(url);
  }

  getDonation(donationId: string) {
    return this.http.post(`${this.environment.apiUrl}/donations/getDonationById`, {id: donationId});
  }
}